import { render, staticRenderFns } from "./dropdown-grade.html?vue&type=template&id=1638a3bd&"
import script from "./dropdown-grade.vue?vue&type=script&lang=js&"
export * from "./dropdown-grade.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-grade.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports